import Vue from 'vue'
import selectCoupon from './component/index.vue'
import axios from '@/axios-mock';
import toast from '@/plugins/toast'
import slide from '@/components/slide'
import bridge from '@beastshop/bridge'
import browser from '@beastshop/browser'

Vue.use(toast)
const isApp = browser.app()
let vm, _resolve, _reject
let plugin =  {
  install (vue, options) {
    
    vue.prototype.$selectCoupon= (data) => {
      // if (isApp) {
      //   return bridge.selectProductVariant(data)
      // }

      const _pomise = new Promise((resolve, reject) => {
        _resolve = resolve
        _reject = reject
      })

      vm = new Vue({
        el: document.createElement('div'),
        template: `<select-coupon :data="data" :show="show" @complete="complete" @select="select"/>
          `,
        data: {
          data: data,
          show: false
        },
        components: {
          'select-coupon': selectCoupon,
          slide
        },
        methods: {
          complete (result) {
            this.close()
    
            result === null
              ? _reject(cancelError())
              : _resolve(result)
          },

          select (couponId) {
            this.$ensureLogged()
            .then(({alreadyLogged}) => {
              axios({
                url: `/app/activity/receive/coupon/${couponId}`
              })
              .then(({data}) => {
                this.$toast('优惠券已到账, 请在【个人中心】-【我的卡券】查询！')
              })
              .catch(err => {
                this.$toast(err.message)
              })
            })
          },

          // error (message) {
          //   this.close()
          //   _reject(message)
          // },
          close () {
            this.show = false
            stopBodyScroll(false)
                          
            document.body.style.position = 'initial'
            document.body.style.height = 'auto'
            if (vm) {
              document.body.removeChild(vm.$el)
            }
          },
          maskTap () {
            this.close()
            _reject(cancelError())
          }
        }
      }) 
      document.body.appendChild(vm.$el)
      setTimeout(() => {
        vm.show = true 
        stopBodyScroll(true)
        
        document.body.style.position = 'fixed'
        document.body.style.width = '100%' 
      }, 0)

      // return new Promise((resolve, reject) => {
      //   _resolve = resolve
      //   _reject = reject
      // })
      return _pomise
    }
  }
}

Vue.use(plugin)

function cancelError(){
  const error = new Error('USER_CANCEL')
  error.code = 'USER_CANCEL'
  return error
}


function bodyScroll(event){  
  event.preventDefault();  
}

let top1 = 0

function stopBodyScroll(isFixed) {
  var bodyEl = document.body
  if (isFixed) {
    top1 = window.scrollY
    bodyEl.style.position = 'fixed'
    bodyEl.style.top = -top1 + 'px'
  }else{
    bodyEl.style.position = ''
    bodyEl.style.top = ''
    window.scrollTo(0, top1)
  }
}

// this.$selectVariant({
//   data:123
// })
//   .then((result) => {
    
//   })
//   .catch(() => {
    
//   })


// WEBPACK FOOTER //
// ./static/plugins/select-coupon/index.js